<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import ReadMoreText from './assets/readmoretext.svg?component';
  import Badge from './Badge.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  interface Props {
    placement: 'none' | 'topRight' | 'topLeft' | 'bottomLeft' | 'bottomRight';
    mask: string | undefined;
    animate?: boolean;
    sourceMap: ContentSourceMap | undefined;
    path?: StudioPathLike;
  }

  let { placement, mask, animate = false, sourceMap, path = [] }: Props = $props();

  let encodeDataAttribute = $derived(useEncodeDataAttribute(placement, sourceMap, sanityStudioURL));

  const responsiveVars = new ResponsiveVars()
    .addFluid('badge-size', toFluidVarInput(100, 150))
    .toCSS();
</script>

<div
  class={cx('read-more-badge', responsiveVars, placement, mask)}
  data-sanity={encodeDataAttribute([...path, 'badge'])}
>
  <Badge {animate} includeGlow={true}>
    {#snippet text()}
      <ReadMoreText />
    {/snippet}
  </Badge>
</div>

<style lang="scss">
  @import 'src/scss/media';

  .read-more-badge {
    position: absolute;
    width: var(--badge-size);
    height: var(--badge-size);

    z-index: 2;

    &.none {
      display: none;
    }

    &.topLeft {
      &.clover {
        top: 5%;
        left: 15%;
      }

      &.halfPill {
        left: 3%;
        top: 3%;
      }
    }

    &.topRight {
      left: 100%;
      transform: translateX(-100%) translateY(10%);

      &.clover {
        left: 85%;
        top: 5%;
      }

      &.halfPill {
        left: 97%;
        top: 3%;
      }
    }

    &.bottomLeft {
      top: 100%;
      transform: translateY(-100%);

      &.clover {
        top: 95%;
        left: 15%;
      }

      &.halfPill {
        left: 3%;
        top: 97%;
      }
    }

    &.bottomRight {
      top: 100%;
      left: 100%;
      transform: translate(-100%, -100%);

      &.clover {
        left: 85%;
        top: 95%;
      }

      &.halfPill {
        left: 97%;
        top: 97%;
      }
    }
  }
</style>
